import {
    GET_PROFILE_DETAILS
} from '../middleware/types'

const initialState = {
    SUBMIT_loading: false,
    error: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_PROFILE_DETAILS:
            return {
                ...state,
                SUBMIT_loading: false,
                profileDetails: action.profileDetails,
            }
        default:
            return state
    }
}